// import React, { useEffect, useState, useMemo, Suspense } from "react";
// import ServiceForm from "../components/ServiceForm";
// import { FaSpinner, FaTimes, FaCheck, FaExclamationTriangle } from "react-icons/fa";
// import { useLanguage } from "../components/LanguajeContext";
// import translations from "../utils/service.translate";
// import { supabase } from "../utils/supabaseClient";

// // Lazy load de iconos
// const FaEdit = React.lazy(() => import("react-icons/fa").then(mod => ({ default: mod.FaEdit })));
// const FaPowerOff = React.lazy(() => import("react-icons/fa").then(mod => ({ default: mod.FaPowerOff })));
// const FaToggleOn = React.lazy(() => import("react-icons/fa").then(mod => ({ default: mod.FaToggleOn })));
// const FaTrash = React.lazy(() => import("react-icons/fa").then(mod => ({ default: mod.FaTrash })));

// // Componente de mensaje de error mejorado
// const ErrorMessage = ({ message, onClose }) => (
//   <div className="mb-4 p-4 bg-red-500/20 border border-red-500/50 text-white rounded-xl flex items-start gap-3 animate-fade-in">
//     <div className="flex-shrink-0 mt-0.5">
//       <FaExclamationTriangle className="text-red-400 text-xl" />
//     </div>
//     <div className="flex-1">
//       <p className="font-medium">{message}</p>
//     </div>
//     <button
//       onClick={onClose}
//       className="flex-shrink-0 text-red-300 hover:text-white transition-colors"
//     >
//       <FaTimes />
//     </button>
//   </div>
// );

// // Componente de mensaje de éxito mejorado
// const SuccessMessage = ({ message, onClose }) => (
//   <div className="mb-4 p-4 bg-green-500/20 border border-green-500/50 text-white rounded-xl flex items-start gap-3 animate-fade-in">
//     <div className="flex-shrink-0 mt-0.5">
//       <FaCheck className="text-green-400 text-xl" />
//     </div>
//     <div className="flex-1">
//       <p className="font-medium">{message}</p>
//     </div>
//     <button
//       onClick={onClose}
//       className="flex-shrink-0 text-green-300 hover:text-white transition-colors"
//     >
//       <FaTimes />
//     </button>
//   </div>
// );

// // Componente de tarjeta individual
// // Componente de tarjeta individual
// function ServiceCard({ service, onEdit, onToggle, onDelete, t }) {
//   return (
//    <div className="bg-[#2D4A5E] p-3 rounded-2xl shadow-lg border border-[#335066] transition hover:scale-[1.02] duration-200">
//   {/* Imagen del servicio */}
//   {service.url_image ? (
//     <div className="relative w-full h-56 rounded-xl overflow-hidden mb-4 shadow-lg">
//       <img
//         src={service.url_image}
//         alt={service.name}
//         className="w-full h-full object-cover transition-transform duration-500 hover:scale-105 opacity-0 transition-opacity duration-700"
//         loading="lazy"
//         onLoad={(e) => e.currentTarget.classList.add("opacity-100")}
//       />
//       {/* Overlay sutil para mejorar contraste */}
//       <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-black/10 to-transparent"></div>
//     </div>
//   ) : (
//     <div className="w-full h-56 flex items-center justify-center bg-gradient-to-br from-gray-700 to-gray-800 rounded-xl mb-4 text-gray-400 text-lg italic">
//       {t.noImage || "Sin imagen"}
//     </div>
//   )}

//       <h3 className="text-2xl font-bold text-green-300 mb-3">{service.name}</h3>
//       <p className="text-gray-200 mb-1">{service.description}</p>
//       <p className="text-gray-300"><strong>{t.capacity}:</strong> {service.max_capacity}</p>
//       <p className="text-gray-300"><strong>{t.category}:</strong> {service.category}</p>
//       <p className="text-gray-300"><strong>{t.price}:</strong> ₡{service.price}</p>

//       <div className="mt-4 flex flex-wrap gap-3">
//         <button
//           onClick={() => onEdit(service)}
//           className="bg-green-400 text-black px-4 py-2 rounded-xl hover:bg-green-300 transition flex items-center gap-2"
//         >
//           <Suspense fallback={<FaSpinner className="animate-spin" />}>
//             <FaEdit /> {t.edit}
//           </Suspense>
//         </button>

//         <button
//           onClick={() => onDelete(service.id,service.picture)}
//           className="bg-red-600 text-white px-4 py-2 rounded-xl hover:bg-red-500 transition flex items-center gap-2"
//         >
//           <Suspense fallback={<FaSpinner className="animate-spin" />}>
//             <FaTrash /> {t.delete}
//           </Suspense>
//         </button>
//       </div>
//     </div>
//   );
// }


// // Componente principal
// export default function Service() {
//   const [services, setServices] = useState([]);
//   const [selectedService, setSelectedService] = useState(null);
//   const [showModal, setShowModal] = useState(false);
//   const [errorMsg, setErrorMsg] = useState("");
//   const [successMsg, setSuccessMsg] = useState("");
//   const [loading, setLoading] = useState(true);
  
//   const URL = process.env.REACT_APP_SERVER_URL;
//   const API_URL = `${URL}/api/service`;
//   const id_operator = useMemo(() => localStorage.getItem("id_operator"), []);
//   //const token = useMemo(() => localStorage.getItem("token"), []);
  
//   // Obtener el lenguaje del contexto
//   const { language } = useLanguage();
//   const t = translations[language] || translations.es; // Fallback a español




//   const fetchServices = async () => {
//     if (!id_operator) return;

//     try {
    
//       const response = await fetch(`${API_URL}?id_operator=${id_operator}`, {
//         //headers: { Authorization: `Bearer ${token}` },
//          credentials: "include"
//       });
     
//       if (!response.ok) {
//         const errorData = await response.json();
//         throw new Error(errorData.error || t.errorFetchingServices);
//       }

//       const data = await response.json();
//       setServices(data.map(s => ({ ...s, id: s.id_service })));
//     } catch (error) {
//       setErrorMsg(error.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchServices();
//   }, [language]); // Recargar servicios cuando cambia el idioma

//   const handleEditClick = (service) => {
//     setSelectedService(service);
//     setShowModal(true);
//     setErrorMsg("");
//     setSuccessMsg("");
//   };

  

//   const handleDeleteService = async (id, picture) => {
//     console.log("picture",picture)
//     if (!window.confirm(t.confirmDelete)) {
//       return;
//     }

//     try {
//       const response = await fetch(`${API_URL}/${id}`, {
//         method: "DELETE",
//         headers: {
//           "Content-Type": "application/json",
//           //Authorization: `Bearer ${token}`,
          

//         },
//         credentials:"include",
//         body: JSON.stringify({picture})
        
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
        
//         // Verificar si el error es por reservaciones existentes
//         if (response.status === 409) {
//           console.log("error ", errorData.error)
//         if (errorData.error.code=="SERVICE_BOOKED"){
//           throw new Error(t.cannotDeleteDueToReservations);

//           }
//          if(errorData.error.code=="SERVICE_LOCKED"){
//             console.log("error", "pending")
//             throw new Error(t.cannotDeleteongoingprocess)
//           }
          

//         }
        
//         throw new Error(errorData.error.message || t.deleteError);
//       }

//       // Eliminar el servicio 
//       // de la lista localmente
//       setServices(prev => prev.filter(service => service.id !== id));
//       setSuccessMsg(t.deleteSuccess);
      
//       // Limpiar mensaje después de un tiempo
//       setTimeout(() => {
//         setSuccessMsg("");
//       }, 3000);
//     } catch (error) {
//       setErrorMsg(error.message);
      
//       // Limpiar mensaje de error después de un tiempo
//       setTimeout(() => {
//         setErrorMsg("");
//       }, 5000);
//     }
//   };
  

//   const handleFormSubmit = async (formData) => {
//     if (!id_operator) {
//       setErrorMsg(t.operatorIdNotFound);
//       return;
//     }
//    let filePath;
//    const pictureFile=formData.image
//    console.log("subiendo imagen")
//    console.log("picture", pictureFile)
//     if(pictureFile){
//       const fileExt = pictureFile.name.split(".").pop();
//       const fileName = `${Date.now()}.${fileExt}`
//       filePath = `services/${fileName}`;
      
//       const { error } = await supabase.storage
//               .from("images_services")
//               .upload(filePath, pictureFile, {
//                 cacheControl: "3600",
//                 upsert: false,
//       });
//       if (error) {
//         console.error("Upload error:", error.message);
//         ErrorMessage(t.image_error);
//         return;
//       }

      


//     }
//     const dataToSend = {
//       ...formData,
//       id_operator,
//       picture:filePath? filePath:selectedService?.picture||null,
//       id_service: selectedService?.id || null,
//     };

//     try {
//       let response;
//       if (selectedService) {
//         response = await fetch(`${API_URL}/update`, {
//           method: "PUT",
//           headers: {
//             "Content-Type": "application/json",
//             //Authorization: `Bearer ${token}`,
          
//           },
//           credentials:"include",
//           body: JSON.stringify(dataToSend),
//         });
//       } else {
//         response = await fetch(`${API_URL}/create-service`, {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             //Authorization: `Bearer ${token}`,
          

//           },
//           credentials:"include",
//           body: JSON.stringify(dataToSend),
//         });
//       }

//       if (!response.ok) {
//         console.log("is no okay")
//         const errorData = await response.json();
        
//         if (response.status === 409) {
//           //console.log("errorrrr", t.cannotUpdateDueToReservations)
//           if(errorData.error.code=="SERVICE_BOOKED")
//           throw new Error(t.cannotUpdateDueToReservations);
//         }
//         if(errorData.error.code="SERVICE_LOCKED"){
//           throw new Error(t.cannotUpdateongoingprocess)
//         }
        
//         throw new Error(t.operationError);
//       }

//       await fetchServices();

//       setSuccessMsg(t.operationSuccess);
//       setTimeout(() => {
//         setShowModal(false);
//         setSelectedService(null);
//         setErrorMsg("");
//         setSuccessMsg("");
//       }, 1200);
//     } catch (error) {
      
      
//       throw error
//     }
//   };

//   // Función para cerrar mensajes manualmente
//   const closeErrorMsg = () => setErrorMsg("");
//   const closeSuccessMsg = () => setSuccessMsg("");

//   return (
//     <div className="min-h-screen bg-[#102B3F] text-white p-6">
//       <h2 className="text-4xl font-bold mb-6 text-green-300">{t.serviceManagement}</h2>

//       {/* Mensajes de éxito y error globales */}
//       {errorMsg && (
//         <ErrorMessage message={errorMsg} onClose={closeErrorMsg} />
//       )}
//       {successMsg && (
//         <SuccessMessage message={successMsg} onClose={closeSuccessMsg} />
//       )}

//       <button
//         onClick={() => {
//           setSelectedService(null);
//           setShowModal(true);
//           setErrorMsg("");
//           setSuccessMsg("");
//         }}
//         className="mb-6 bg-green-400 text-black px-5 py-2 rounded-xl hover:bg-green-300 transition font-semibold shadow"
//       >
//         + {t.newService}
//       </button>

//       {loading ? (
//         <div className="text-center text-gray-300">
//           <FaSpinner className="mx-auto animate-spin mb-2" />
//           {t.loadingServices}
//         </div>
//       ) : (
//         <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
//           {services.map((service) => (
//             <ServiceCard
//               key={service.id}
//               service={service}
//               onEdit={handleEditClick}
//               onDelete={handleDeleteService}
//               t={t}
//             />
//           ))}
//         </div>
//       )}

//       {/* Modal de creación/edición */}
//       {showModal && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-sm">
//           <div className="bg-[#1B3A4B] p-6 rounded-2xl shadow-2xl border border-[#335066] w-[90%] max-w-lg animate-fade-in">
//             {errorMsg && (
//               <ErrorMessage message={errorMsg} onClose={closeErrorMsg} />
//             )}
//             {successMsg && (
//               <SuccessMessage message={successMsg} onClose={closeSuccessMsg} />
//             )}

//             <ServiceForm
//               initialData={selectedService || {}}
//               isEditing={!!selectedService}
//               onSubmit={handleFormSubmit}
//               externalError={errorMsg}
//               t={t}
//             />

//             <div className="flex justify-end mt-4">
//               <button
//                 onClick={() => {
//                   setShowModal(false);
//                   setErrorMsg("");
//                   setSuccessMsg("");
//                 }}
//                 className="mt-2 px-4 py-2 bg-gray-500 hover:bg-gray-400 text-white rounded-xl transition"
//               >
//                 {t.cancel}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

import React, { useEffect, useState, useMemo, Suspense } from "react";
import ServiceForm from "../components/ServiceForm";
import { FaSpinner, FaTimes, FaCheck, FaExclamationTriangle } from "react-icons/fa";
import { useLanguage } from "../components/LanguajeContext";
import translations from "../utils/service.translate";
import { supabase } from "../utils/supabaseClient";

// Lazy load de iconos
const FaEdit = React.lazy(() => import("react-icons/fa").then(mod => ({ default: mod.FaEdit })));
const FaPowerOff = React.lazy(() => import("react-icons/fa").then(mod => ({ default: mod.FaPowerOff })));
const FaToggleOn = React.lazy(() => import("react-icons/fa").then(mod => ({ default: mod.FaToggleOn })));
const FaTrash = React.lazy(() => import("react-icons/fa").then(mod => ({ default: mod.FaTrash })));

// Componente de mensaje de error mejorado
const ErrorMessage = ({ message, onClose }) => (
  <div className="mb-4 p-4 bg-red-500/20 border border-red-500/50 text-white rounded-xl flex items-start gap-3 animate-fade-in">
    <div className="flex-shrink-0 mt-0.5">
      <FaExclamationTriangle className="text-red-400 text-xl" />
    </div>
    <div className="flex-1">
      <p className="font-medium">{message}</p>
    </div>
    <button
      onClick={onClose}
      className="flex-shrink-0 text-red-300 hover:text-white transition-colors"
    >
      <FaTimes />
    </button>
  </div>
);

// Componente de mensaje de éxito mejorado
const SuccessMessage = ({ message, onClose }) => (
  <div className="mb-4 p-4 bg-green-500/20 border border-green-500/50 text-white rounded-xl flex items-start gap-3 animate-fade-in">
    <div className="flex-shrink-0 mt-0.5">
      <FaCheck className="text-green-400 text-xl" />
    </div>
    <div className="flex-1">
      <p className="font-medium">{message}</p>
    </div>
    <button
      onClick={onClose}
      className="flex-shrink-0 text-green-300 hover:text-white transition-colors"
    >
      <FaTimes />
    </button>
  </div>
);

// Componente de tarjeta individual
function ServiceCard({ service, onEdit, onDelete, t }) {
  return (
    <div className="bg-[#2D4A5E] p-4 rounded-2xl shadow-lg border border-[#335066] transition hover:scale-[1.02] duration-200">
      {/* Imagen del servicio */}
      {service.url_image ? (
        <div className="relative w-full h-48 sm:h-56 rounded-xl overflow-hidden mb-4 shadow-lg">
          <img
            src={service.url_image}
            alt={service.name}
            className="w-full h-full object-cover transition-transform duration-500 hover:scale-105 opacity-0 transition-opacity duration-700"
            loading="lazy"
            onLoad={(e) => e.currentTarget.classList.add("opacity-100")}
          />
          {/* Overlay sutil para mejorar contraste */}
          <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-black/10 to-transparent"></div>
        </div>
      ) : (
        <div className="w-full h-48 sm:h-56 flex items-center justify-center bg-gradient-to-br from-gray-700 to-gray-800 rounded-xl mb-4 text-gray-400 text-sm sm:text-lg italic px-2 text-center">
          {t.noImage || "Sin imagen"}
        </div>
      )}

      <h3 className="text-xl sm:text-2xl font-bold text-green-300 mb-3 break-words">{service.name}</h3>
      <p className="text-gray-200 mb-1 text-sm sm:text-base break-words">{service.description}</p>
      <p className="text-gray-300 text-sm sm:text-base"><strong>{t.capacity}:</strong> {service.max_capacity}</p>
      <p className="text-gray-300 text-sm sm:text-base"><strong>{t.category}:</strong> {service.category}</p>
      <p className="text-gray-300 text-sm sm:text-base"><strong>{t.price}:</strong> ₡{service.price}</p>

      <div className="mt-4 flex flex-col sm:flex-row gap-2 sm:gap-3">
        <button
          onClick={() => onEdit(service)}
          className="bg-green-400 text-black px-3 sm:px-4 py-2 rounded-xl hover:bg-green-300 transition flex items-center justify-center gap-2 text-sm sm:text-base"
        >
          <Suspense fallback={<FaSpinner className="animate-spin" />}>
            <FaEdit /> {t.edit}
          </Suspense>
        </button>

        <button
          onClick={() => onDelete(service.id,service.picture)}
          className="bg-red-600 text-white px-3 sm:px-4 py-2 rounded-xl hover:bg-red-500 transition flex items-center justify-center gap-2 text-sm sm:text-base"
        >
          <Suspense fallback={<FaSpinner className="animate-spin" />}>
            <FaTrash /> {t.delete}
          </Suspense>
        </button>
      </div>
    </div>
  );
}

// Componente principal
export default function Service() {
  const [services, setServices] = useState([]);
  const [selectedService, setSelectedService] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [loading, setLoading] = useState(true);
  
  const URL = process.env.REACT_APP_SERVER_URL;
  const API_URL = `${URL}/api/service`;
  const id_operator = useMemo(() => localStorage.getItem("id_operator"), []);
  //const token = useMemo(() => localStorage.getItem("token"), []);
  
  // Obtener el lenguaje del contexto
  const { language } = useLanguage();
  const t = translations[language] || translations.es; // Fallback a español

  const fetchServices = async () => {
    if (!id_operator) return;

    try {
    
      const response = await fetch(`${API_URL}?id_operator=${id_operator}`, {
        //headers: { Authorization: `Bearer ${token}` },
         credentials: "include"
      });
     
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || t.errorFetchingServices);
      }

      const data = await response.json();
      setServices(data.map(s => ({ ...s, id: s.id_service })));
    } catch (error) {
      setErrorMsg(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchServices();
  }, [language]); // Recargar servicios cuando cambia el idioma

  const handleEditClick = (service) => {
    setSelectedService(service);
    setShowModal(true);
    setErrorMsg("");
    setSuccessMsg("");
  };

  const handleDeleteService = async (id, picture) => {
    console.log("picture",picture)
    if (!window.confirm(t.confirmDelete)) {
      return;
    }

    try {
      const response = await fetch(`${API_URL}/${id}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          //Authorization: `Bearer ${token}`,
        },
        credentials:"include",
        body: JSON.stringify({picture})
      });

      if (!response.ok) {
        const errorData = await response.json();
        
        // Verificar si el error es por reservaciones existentes
        if (response.status === 409) {
          console.log("error ", errorData.error)
        if (errorData.error.code=="SERVICE_BOOKED"){
          throw new Error(t.cannotDeleteDueToReservations);
          }
         if(errorData.error.code=="SERVICE_LOCKED"){
            console.log("error", "pending")
            throw new Error(t.cannotDeleteongoingprocess)
          }
        }
        
        throw new Error(errorData.error.message || t.deleteError);
      }

      // Eliminar el servicio de la lista localmente
      setServices(prev => prev.filter(service => service.id !== id));
      setSuccessMsg(t.deleteSuccess);
      
      // Limpiar mensaje después de un tiempo
      setTimeout(() => {
        setSuccessMsg("");
      }, 3000);
    } catch (error) {
      setErrorMsg(error.message);
      
      // Limpiar mensaje de error después de un tiempo
      setTimeout(() => {
        setErrorMsg("");
      }, 5000);
    }
  };

  const handleFormSubmit = async (formData) => {
    if (!id_operator) {
      setErrorMsg(t.operatorIdNotFound);
      return;
    }
   let filePath;
   const pictureFile=formData.image
   console.log("subiendo imagen")
   console.log("picture", pictureFile)
    if(pictureFile){
      const fileExt = pictureFile.name.split(".").pop();
      const fileName = `${Date.now()}.${fileExt}`
      filePath = `services/${fileName}`;
      
      const { error } = await supabase.storage
              .from("images_services")
              .upload(filePath, pictureFile, {
                cacheControl: "3600",
                upsert: false,
      });
      if (error) {
        console.error("Upload error:", error.message);
        ErrorMessage(t.image_error);
        return;
      }
    }
    
    const dataToSend = {
      ...formData,
      id_operator,
      picture:filePath? filePath:selectedService?.picture||null,
      id_service: selectedService?.id || null,
    };

    try {
      let response;
      if (selectedService) {
        response = await fetch(`${API_URL}/update`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            //Authorization: `Bearer ${token}`,
          },
          credentials:"include",
          body: JSON.stringify(dataToSend),
        });
      } else {
        response = await fetch(`${API_URL}/create-service`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            //Authorization: `Bearer ${token}`,
          },
          credentials:"include",
          body: JSON.stringify(dataToSend),
        });
      }

      if (!response.ok) {
        console.log("is no okay")
        const errorData = await response.json();
        
        if (response.status === 409) {
          if(errorData.error.code=="SERVICE_BOOKED")
          throw new Error(t.cannotUpdateDueToReservations);
        }
        if(errorData.error.code="SERVICE_LOCKED"){
          throw new Error(t.cannotUpdateongoingprocess)
        }
        
        throw new Error(t.operationError);
      }

      await fetchServices();

      setSuccessMsg(t.operationSuccess);
      setTimeout(() => {
        setShowModal(false);
        setSelectedService(null);
        setErrorMsg("");
        setSuccessMsg("");
      }, 1200);
    } catch (error) {
      throw error
    }
  };

  // Función para cerrar mensajes manualmente
  const closeErrorMsg = () => setErrorMsg("");
  const closeSuccessMsg = () => setSuccessMsg("");

  return (
    <div className="min-h-screen bg-[#102B3F] text-white p-4 sm:p-6">
      <h2 className="text-2xl sm:text-4xl font-bold mb-6 text-green-300">{t.serviceManagement}</h2>

      {/* Mensajes de éxito y error globales */}
      {errorMsg && (
        <ErrorMessage message={errorMsg} onClose={closeErrorMsg} />
      )}
      {successMsg && (
        <SuccessMessage message={successMsg} onClose={closeSuccessMsg} />
      )}

      <button
        onClick={() => {
          setSelectedService(null);
          setShowModal(true);
          setErrorMsg("");
          setSuccessMsg("");
        }}
        className="mb-6 bg-green-400 text-black px-4 sm:px-5 py-2 rounded-xl hover:bg-green-300 transition font-semibold shadow w-full sm:w-auto text-sm sm:text-base"
      >
        + {t.newService}
      </button>

      {loading ? (
        <div className="text-center text-gray-300">
          <FaSpinner className="mx-auto animate-spin mb-2" />
          {t.loadingServices}
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
          {services.map((service) => (
            <ServiceCard
              key={service.id}
              service={service}
              onEdit={handleEditClick}
              onDelete={handleDeleteService}
              t={t}
            />
          ))}
        </div>
      )}

      {/* Modal de creación/edición */}
      {showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-sm p-2 sm:p-4">
          <div className="bg-[#1B3A4B] p-4 sm:p-6 rounded-2xl shadow-2xl border border-[#335066] w-full max-w-lg max-h-[90vh] overflow-y-auto animate-fade-in">
            {errorMsg && (
              <ErrorMessage message={errorMsg} onClose={closeErrorMsg} />
            )}
            {successMsg && (
              <SuccessMessage message={successMsg} onClose={closeSuccessMsg} />
            )}

            <ServiceForm
              initialData={selectedService || {}}
              isEditing={!!selectedService}
              onSubmit={handleFormSubmit}
              externalError={errorMsg}
              t={t}
            />

            <div className="flex justify-end mt-4">
              <button
                onClick={() => {
                  setShowModal(false);
                  setErrorMsg("");
                  setSuccessMsg("");
                }}
                className="mt-2 px-4 py-2 bg-gray-500 hover:bg-gray-400 text-white rounded-xl transition text-sm sm:text-base"
              >
                {t.cancel}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}